"use strict";
// packages/contracts/src/piloto-recebimento.ts — Fase 10, Plano 11 (OMIE-13, D-38..D-42).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=piloto-recebimento.js.map